import { FC } from 'react';
import styled from 'styled-components';

import { MpOl } from 'shared/ui/MpOl';
import { MpText } from 'shared/ui/MpText';

const ImgStyled = styled.img`
	margin-top: 16px;
	margin-bottom: 12px;
	margin-left: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 100%;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 450px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 690px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		margin-left: 46px;
	}
`;

const ListStyled = styled(MpOl)`
	gap: 12px;
	margin-bottom: 24px;
`;

export const KonsolInstruction: FC = () => (
	<section>
		<ListStyled>
			<li>
				<MpText>
					Нажмите кнопку «Подключить». Если&nbsp;вы&nbsp;новый пользователь, оформите заявку на&nbsp;получение
					доступа к&nbsp;платформе Konsol.Pro и&nbsp;роли Админ.
					Если&nbsp;у&nbsp;вас&nbsp;уже&nbsp;есть&nbsp;учетная запись, перейдите по&nbsp;кнопке
					«Есть&nbsp;доступ в&nbsp;Konsol.Pro».
				</MpText>
			</li>
			<li>
				<MpText>
					Войдите в&nbsp;личный кабинет Konsol.Pro под&nbsp;учетной записью с&nbsp;ролью бухгалтера. Роль
					бухгалтера может назначить пользователь с&nbsp;ролью Админ.
				</MpText>
			</li>
			<li>
				<MpText>
					Перейдите во&nbsp;вкладку «Интеграции», выберите Додо IS и&nbsp;нажмите на&nbsp;кнопку «Подключить».
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-1-new'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					Введите данные учетной записи для&nbsp;Додо IS в&nbsp;открывшемся окне. Статус «Подключено»
					означает, что&nbsp;вход выполнен успешно.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-2'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>Перейдите в&nbsp;раздел «Акты» и&nbsp;нажмите на&nbsp;кнопку «Сформировать реестр».</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-3-new'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					Задайте период для&nbsp;формирования вознаграждения, а&nbsp;затем нажмите кнопку «Сформировать».
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-4-new'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					Дождитесь формирования реестра. Процесс занимает до&nbsp;трех минут. Документ сохранится
					на&nbsp;рабочий стол.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-5'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					Проверьте реестр на&nbsp;корректность.
					<br />
					Исполнители без&nbsp;указанного в&nbsp;системе Додо IS ИНН&nbsp;в&nbsp;колонке «inn» будут иметь
					значение «??????????». Для&nbsp;таких исполнителей нельзя сформировать&nbsp;акт. Обновите данные
					в&nbsp;Додо IS и сформируйте акт заново.
					<br />
					<br />
					Проверьте значение указанных премий за&nbsp;период в&nbsp;колонке «shifts_premiums»,
					чтобы&nbsp;избежать формирования неверных вознаграждений. Если присутствует ошибка — исправьте
					значения в колонке.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-6-new'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					Загрузите проверенный реестр через&nbsp;кнопку «Загрузить из&nbsp;файла». Выберите файл
					или&nbsp;перетащите в&nbsp;окно загрузки.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-7-new'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					Система проверит соответствие данных исполнителей в&nbsp;выгруженном реестре из&nbsp;Додо IS
					в&nbsp;Konsol.pro и&nbsp;укажет на&nbsp;возможное несоответствие данных. Исправьте несоответствия
					и&nbsp;загрузите реестр заново.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-8'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>Нажмите на&nbsp;кнопку «Сформировать 100&nbsp;актов».</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-9'
					style={{ marginBottom: `24px` }}
				/>
			</li>
		</ListStyled>
	</section>
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const KonsolInstruction_eng: FC = () => (
	<section>
		<ListStyled>
			<li>
				<MpText>
					Click the &quot;Connect&quot; button. If you are a new user, submit a request for access to the
					Konsol.Pro platform and the Admin role. If you already have an account, click the &quot;Already have
					access to Konsol.Pro&quot; button.
				</MpText>
			</li>
			<li>
				<MpText>
					Log in to the Konsol.Pro personal account under the account with the accountant role. The accountant
					role can be assigned by a user with the Admin role.
				</MpText>
			</li>
			<li>
				<MpText>
					Go to the &quot;Integrations&quot; tab, select Dodo IS, and click the &quot;Connect&quot; button.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-1-new'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					Enter the account details for Dodo IS in the opened window. The &quot;Connected&quot; status
					indicates a successful login.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-2'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>Go to the &quot;Acts&quot; section and click the &quot;Generate Register&quot; button.</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-3-new'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>Set the period for payment generation and then click the &quot;Generate&quot; button.</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-4-new'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					Wait for the register to be generated. The process takes up to three minutes. The document will be
					saved to the desktop.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-5'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					Check the register for correctness.
					<br />
					Performers without the INN specified in the Dodo IS system in the &quot;inn&quot; column will have
					the value &quot;??????????&quot;. For such performers, it is not possible to generate an act. Update
					the data in Dodo IS and generate the act again.
					<br />
					<br />
					Check the value of the specified bonuses for the period in the &quot;shifts_premiums&quot; column to
					avoid generating incorrect payments. If an error is present, correct the values in the column.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-6-new'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					Upload the verified register through the &quot;Load from File&quot; button. Select the file or drag
					it into the upload window.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-7-new'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>
					The system will check the correspondence of performer data in the uploaded register from Dodo IS to
					Konsol.pro and indicate possible mismatches. Correct the mismatches and upload the register again.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-8'
					style={{ marginBottom: `24px` }}
				/>
			</li>
			<li>
				<MpText>Click the &quot;Generate 100 Acts&quot; button.</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/konsol/instruction-9'
					style={{ marginBottom: `24px` }}
				/>
			</li>
		</ListStyled>
	</section>
);
